export default __webpack_public_path__ + "static/media/William_McCoy_Resume_5726.f4c02314.pdf";